import { Box, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";

import { getPrintableInvoices } from "../utils";
import Header from "./Header";
import InsurerInvoice from "./InsurerInvoice";
import InvoiceTable from "./InvoiceTable";
import PatientDetails from "./PatientDetails";

const useStyles = makeStyles({
  containerWrapper: {
    display: "none",
  },
  printWrapper: {
    margin: "5mm",
  },
  box: {
    margin: "0 15px",
  },
});

// This must be a comp to work with react-to-print
export class ComponentToPrint extends React.Component {
  render() {
    const { classes = {}, invoice, invoicesToPrint } = this.props;
    if (!invoice) {
      return null;
    }
    const invoicesToBePrinted = getPrintableInvoices(
      invoicesToPrint,
      invoice?.payers,
    );
    if (invoicesToBePrinted?.length > 0) {
      return (
        <div>
          {invoicesToBePrinted.map((insurerInvoice) => (
            <InsurerInvoice
              key={insurerInvoice._id}
              invoice={invoice}
              insurer={insurerInvoice}
            />
          ))}
        </div>
      );
    }
    return (
      <div className={classes.printWrapper}>
        <Box className={classes.box}>
          <Header invoice={invoice} />
          <PatientDetails invoice={invoice} />
          <InvoiceTable invoice={invoice} />
        </Box>
      </div>
    );
  }
}

ComponentToPrint.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  invoice: PropTypes.shape({
    payers: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  invoicesToPrint: PropTypes.arrayOf(PropTypes.string).isRequired,
};

class ReactToPrintRemoteTrigger extends ReactToPrint {
  // Overrides `ReactToPrint` to remove need for triggerElement in render method
  render() {
    return <div />;
  }
}

const PrintableInvoice = (props) => {
  const componentRef = useRef();
  const invoiceRef = useRef();
  const classes = useStyles();
  const { onAfterPrint } = props;

  // On didMount - trigger native print
  useEffect(() => {
    invoiceRef.current.handleClick();
  }, []);

  return (
    <div>
      <ReactToPrintRemoteTrigger
        ref={invoiceRef}
        content={() => componentRef.current}
        pageStyle="@page{ size: a4; } @media print{  }"
        onAfterPrint={onAfterPrint}
      />
      <div className={classes.containerWrapper}>
        <ComponentToPrint ref={componentRef} classes={classes} {...props} />
      </div>
    </div>
  );
};

PrintableInvoice.propTypes = {
  onAfterPrint: PropTypes.func.isRequired,
  invoice: PropTypes.shape({}).isRequired,
  invoicesToPrint: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PrintableInvoice;
